<template>
    <b-tab title="Permissions">
        <div class="d-flex mb-3 w-auto">
            <div class="h4 mr-3">
                Permissions
            </div>
            <div class="ml-auto mr-2">
                <b-button variant="success" @click.prevent="show_permission_modal = true" :disabled="!can_create_permissions">
                    <font-awesome-icon :icon="['fad', 'plus-square']" /> Add Permission
                </b-button>
            </div>
        </div>
        <div>
            <b-spinner v-if="loading" label="Loading..."></b-spinner>
            <b-table
                v-else
                striped
                responsive
                sticky-header
                outlined
                no-border-collapse
                head-variant="light"
                :items="permissions"
                :fields="fields"
            >
                <template #cell(roles)="data">
                    <b-badge
                        variant="secondary"
                        v-for="item in data.value"
                        class="m-1"
                        :key="item.id"
                    >
                        {{ item.name }}
                    </b-badge>
                </template>

                <template #cell(actions)="data">
                    <div class="p-1">
                        <b-btn
                            class="m-1"
                            size="sm"
                            variant="outline-primary"
                            @click="editPermission(data.item)"
                            :disabled="!can_edit_permissions"
                        >
                            <font-awesome-icon :icon="['fad', 'edit']" fixed-width /> Edit
                        </b-btn>
                        <b-btn
                            class="m-1"
                            size="sm"
                            variant="outline-danger"
                            @click="deletePermission(data.item)"
                            :disabled="!can_delete_permissions"
                        >
                            <font-awesome-icon :icon="['fad', 'trash']" fixed-width /> Delete
                        </b-btn>
                    </div>
                </template>
            </b-table>
        </div>

        <permission-modal
            :visible="show_permission_modal"
            :permission="editable_permission"
            @hide="clearPermission"
        />
    </b-tab>
</template>

<style></style>

<script>
import { mapState } from 'vuex'
import PermissionModal from '@/components/modals/admin/PermissionModal.vue'
import moment from 'moment'

export default {
    name: 'PermissionsTab',
    components: {PermissionModal},
    data: () => ({
        loading: false,
        fields: [
            {
                key: 'id',
                sortable: true,
                order_number: 1,
                thStyle: {
                    'width': '5%'
                },
            },
            {
                key: 'name',
                sortable: true,
                order_number: 2,
                thStyle: {
                    'width': '30%'
                },
            },
            {
                key: 'roles',
                sortable: false,
                order_number: 3,
                thStyle: {
                    'width': '55%'
                },
            },
            {
                key: 'actions',
                sortable: false,
                order_number: 4,
                thStyle: {
                    'width': '10%'
                },
            },
        ],
        show_permission_modal: false,
        editable_permission: null,
    }),
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            user: state => state.user.user,
            permissions: state => state.admin.permissions,
        }),
        can_create_permissions() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'create_permission')
        },
        can_edit_permissions() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'update_permission')
        },
        can_delete_permissions() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'delete_permission')
        },
    },
    methods: {
        editPermission(permission) {
            this.editable_permission = permission
            this.show_permission_modal = true
        },
        clearPermission() {
            this.editable_permission = null
            this.show_permission_modal = false
        },
        async deletePermission(permission) {
            const result = await this.$swal({
                html: `Delete permission "${permission.name}" ?`,
                showCancelButton: true,
                confirmButtonText: `Delete ${permission.name}`,
                confirmButtonColor: '#E74C3C',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })

            if (result.isConfirmed) {
                try {
                    await this.$store.dispatch('deleteAdminPermission', permission.id)
                    // reload the stores that would be updated
                    await this.$store.dispatch('getAdminPermissions')
                    await this.$store.dispatch('getAdminRoles')
                } catch(e) {
                    await this.$store.dispatch('pushError', {
                        data: {
                            message: `Failed to delete permission: ${e.message}`,
                        },
                        time: moment().toISOString(),
                    })
                }
            }
        },
        async getPermissions() {
            try {
                this.loading = true
                await this.$store.dispatch('getAdminPermissions')
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to read permissions: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }

            this.loading = false
        },
    },
    mounted() {
        this.getPermissions()
    }
}
</script>
